export const getters = {
  getLayers: state => {
    return state.layers
  },
  getDates: state => {
    return state.dates
  },
  getFilteredDates: (state, getters, rootState) => {
    const filters = rootState.geo.projectFilters
    const templateIds = filters?.templateIds
    if (!templateIds || templateIds.length === 0) return state.dates
    return state.dates.filter(d => {
      // dates have id like "template_42" or "radar", extract numeric part
      const match = String(d.id).match(/template_(\d+)/)
      if (!match) return true // keep non-template entries (e.g. radar)
      const id = parseInt(match[1])
      return templateIds.includes(id) || templateIds.includes(String(id))
    })
  },
  getSelectedRange: state => {
    return state.selectedRange
  },
  // New organization layers getters
  getOrgLayers: state => (orgId) => {
    return state.orgLayers[orgId] || []
  },
  getOrgLayerById: state => (orgId, layerId) => {
    const orgLayers = state.orgLayers[orgId] || []
    for (const layer of orgLayers) {
      if (layer.uuid === layerId) return layer
      const children = layer.properties?.children || []
      for (const child of children) {
        if (child.uuid === layerId) return child
      }
    }
    return undefined
  },
  getSelectedFeature: state => {
    return state.selectedFeature
  },
  getActiveResult: state => (layerId) => {
    return state.activeResults[layerId] || null
  },
  getSubscriptionResults: state => (orgId, layerCode) => {
    return state.subscriptionResults?.[orgId]?.[layerCode] || null
  },
  getPlanetscopeSelection: state => (layerId) => {
    return state.planetscopeSelection[layerId] || null
  },
  getMapViewSettings: state => (mapId) => {
    return state.mapViewSettings[mapId] || null
  },
  getOrderProductBundle: state => (layerId) => {
    return state.orderProductBundle[layerId] || null
  },
  getPlanetVarsSelection: state => (layerId) => {
    return state.planetVarsSelection[layerId] || null
  },
  getLulcActiveMonth: state => (parentCode) => {
    return state.lulcActiveMonths[parentCode] || null
  },
  getTempLayers: state => (orgId) => {
    return state.tempLayers[orgId] || []
  },
  getSelectedLayers: state => (orgId) => {
    return state.selectedLayers[orgId] || {}
  },
  isLayerSelected: state => (orgId, layerCode) => {
    return !!(state.selectedLayers[orgId]?.[layerCode])
  },
  getSelectedLayerCount: state => (orgId) => {
    return Object.keys(state.selectedLayers[orgId] || {}).length
  },
  getClipboardLayer: state => {
    return state.clipboardLayer
  }
}
